import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { NAVY, RADIUS_CARD, SURFACE_CONTAINER_LOW } from 'styles/tokens';

import type { CampaignRow, DrillDownBodyProps } from '../types';

const labelSx = {
  color: alpha(NAVY, 0.55),
  textTransform: 'uppercase' as const,
  letterSpacing: '0.06em',
  fontSize: '0.7rem',
  fontWeight: 600,
  fontFamily: 'Jost, sans-serif',
};

const valueSx = {
  color: NAVY,
  fontFamily: 'Jost, sans-serif',
  fontWeight: 700,
  fontSize: '1.5rem',
};

const WhatsAppDrillDownBody: React.FC<DrillDownBodyProps> = ({ row }) => {
  const raw = row.raw as Extract<CampaignRow['raw'], { whatsAppCampaignId: number }>;
  const totalLeads = raw.totalLeads ?? 0;
  const leadsWithMessagesSent = raw.leadsWithMessagesSent ?? 0;
  const leadsWithClientResponses = raw.leadsWithClientResponses ?? 0;
  const leadsUploadedToCRM = raw.leadsUploadedToCRM ?? 0;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Box
        sx={{
          p: 3,
          borderRadius: RADIUS_CARD,
          bgcolor: SURFACE_CONTAINER_LOW,
          display: 'grid',
          gridTemplateColumns: 'repeat(2, 1fr)',
          gap: 2,
        }}
      >
        <Box>
          <Typography sx={labelSx}>Total de leads</Typography>
          <Typography sx={valueSx}>{totalLeads.toLocaleString('es-CL')}</Typography>
        </Box>
        <Box>
          <Typography sx={labelSx}>Con mensajes enviados</Typography>
          <Typography sx={valueSx}>{leadsWithMessagesSent.toLocaleString('es-CL')}</Typography>
        </Box>
        <Box>
          <Typography sx={labelSx}>Con respuesta del cliente</Typography>
          <Typography sx={valueSx}>{leadsWithClientResponses.toLocaleString('es-CL')}</Typography>
        </Box>
        <Box>
          <Typography sx={labelSx}>Subidos al CRM</Typography>
          <Typography sx={valueSx}>{leadsUploadedToCRM.toLocaleString('es-CL')}</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default WhatsAppDrillDownBody;
